/* eslint-disable no-use-before-define */
/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import TitleBar from "../Layout/titleBar";
import { Row, Col } from "react-flexbox-grid";
import Autocomplete from "react-autocomplete";
import Dialog from "@material-ui/core/Dialog";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ItemDetallePedido from "./itemDetallePedido";
import CurrencyFormat from "react-currency-format";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";
import { formatMoney } from "../Common/decimalHelper";
import TurneroContainer from "../../containers/TurneroContainer";
import DomicilioEntregaContainer from "../../containers/DomicilioEntregaContainer";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import InputAdornment from "@material-ui/core/InputAdornment";
import ClearIcon from "@material-ui/icons/Clear";
import DatosFacturacionModal from "./datosFacturacionModal";
import "./styles.css";
import _axios from "../../apiClient";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Select, MenuItem } from "@material-ui/core";

const getOrigenPedidoLabel = (pedido) => {
  if (pedido.descripcionOrigenPedido || pedido.DescripcionOrigenPedido) {
    return pedido.descripcionOrigenPedido || pedido.DescripcionOrigenPedido;
  }

  const origenPedidoId = pedido.idOrigenPedido ?? pedido.IdOrigenPedido;
  return Number(origenPedidoId) === 2 ? "Whatsapp" : "Ecommerce";
};

const styles = (theme) => ({
  margin: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    outline: "none",
    borderBottom: "none !important",
  },
  show: {
    transform: "translateY(0)",
    transition: "transform .5s",
  },
  disabled: {
    background: "#8080801a",
    color: "#848484 !important",
  },
  rootDialog: {
    zIndex: 1250,
  },
  rootContent: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "-5px 4px 10px #8E8E8E29",
    borderRadius: "21px",
    opacity: 1,
    maxWidth: "850px",
    padding: "0px !important",
  },
  rootQuitar: {
    zIndex: 1200,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "-5px 4px 10px #8E8E8E29",
    borderRadius: "10px",
    opacity: 1,
    padding: "0px !important",
    maxWidth: "650px",
  },
  label: {
    font: "500 16px/20px Poppins",
    letterSpacing: "0px",
    color: "#0C3653",
  },
});

const RadioOrange = withStyles({
  root: {
    color: "var(--button-primary)",
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

function Money(n) {
  var c = 2,
    d = ",",
    t = ".",
    s = n < 0 ? "-" : "",
    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
}

const modalidad = {
  Pickup: 1,
  Delivery: 2,
};

class PedidoDetalle extends React.Component {
  constructor(props, context) {
    super(props, context);

    // Set initial State
    this.state = {
      optionReemplazo: undefined,
      //opcion otro articulo
      value: "",
      itemNuevo: undefined,
      claveErrorMsg: undefined,
      cantidadOriginal: 0,
      isValidPassword: false,
      cantidadNuevoArticulo: 0,
      //opcion distinta cantidad
      nuevaCantidad: 0,
      //quitar
      itemAQuitar: undefined,

      //turnos
      showBtnsModalidadTurnos: false,
      //password
      oldPassword: "",
      // idLocalidadSeleccionada: null,
    };

    // Bind `this` context to functions of the class
    this.onChange = this.onChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.getItemValue = this.getItemValue.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.retrieveDataAsynchronously = this.retrieveDataAsynchronously.bind(this);
    // this.handleLocalidadChange = this.handleLocalidadChange.bind(this);
  }

  // async componentDidMount() {
  //     console.log('this.props. PEDIDO DETALLE', this.props)
  //       this.setState({
  //         idLocalidadSeleccionada: this.props.pedido?.idLocalidadEntrega || null,
  //       });
  //   // try {
  //   //   const localidades = await GetLocalidadesEntregaActivas();
  //   // } catch (error) {
  //   //   this.setState({
  //   //     mensaje: 'Error al cargar las localidades',
  //   //     localidadesCargadas: false
  //   //   });
  //   // }
  //   // this.setState({ isDataLoaded: true });
  // }

  componentDidUpdate(prevProps) {
    if (prevProps.idLocalidadSeleccionada !== this.props.idLocalidadSeleccionada) {
      this.setState({ idLocalidadSeleccionada: this.props.idLocalidadSeleccionada });
    }
  }

  // handleLocalidadChange = (event) => {
  //   console.log('event handleLocalidadChange', event.target.value);
  //   const nuevaLocalidad = event.target.value;

  //   this.setState({
  //     idLocalidadSeleccionada: nuevaLocalidad
  //   }, () => {
  //     // Llama después de actualizar el estado
  //     this.props.handleOnClickTurnosDeliveryPorLocalidadEspecifica(
  //       nuevaLocalidad,
  //       this.props.modalidadSelected // o this.state.modalidadSelected si lo tienes en el estado
  //     );
  //   });
  // }

  retrieveDataAsynchronously(searchText) {
    let payload = {
      busqueda: searchText,
      idInstalacion: this.props.itemReemplazar.idInstalacion,
    };
    this.props.obtenerSugerencias(payload);
  }

  onChange(e) {
    this.setState({
      value: e.target.value,
    });

    if (e.target.value.length >= 3) this.retrieveDataAsynchronously(e.target.value);
  }

  handleOnClickCheckPassword = async (pass) => {
    await _axios
      .get(`/api/Instalacion/AdminPasword?pass=${pass}`)
      .then((res) => {
        const { isValidPassword } = res.data;
        this.setState({ isValidPassword });
        if (!isValidPassword) {
          this.setState({ claveErrorMsg: "Clave de supervisor incorrecta" });
        }
      })
      .catch(() => {
        this.setState({ claveErrorMsg: "Clave de supervisor incorrecta" });
      });
  };

  handleOnChangeInputClave = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    this.setState({ [name]: value });
  };

  onSelect(val, item) {
    this.setState({
      value: val,
      itemNuevo: item,
    });
  }

  renderItem(item, isHighlighted) {
    return (
      <div style={{ background: isHighlighted ? "lightgray" : "white" }}>
        {item.nombre} {item.codigoBarra} {item.codigoInterno}
      </div>
    );
  }

  getItemValue(item) {
    return `${item.nombre} ${item.codigoBarra} ${item.codigoInterno}`;
  }

  handleOnClickOptionReemplazoSelected = (value) => {
    if (value === this.state.optionReemplazo) {
      return;
    }

    this.setState({
      optionReemplazo: value,
      value: "",
      itemNuevo: undefined,
      cantidadOriginal: 0,
      cantidadNuevoArticulo: 0,
      nuevaCantidad: 0,
      itemAQuitar: undefined,
      oldPassword: "",
      isValidPassword: undefined,
      claveErrorMsg: undefined,
    });
  };

  modalReemplazarClose = () => {
    this.setState(
      {
        optionReemplazo: undefined,
        nuevaCantidad: 0,
        isValidPassword: undefined,
        claveErrorMsg: undefined,
      },
      this.props.modalReemplazarClose
    );
  };

  handleOnClickGuardarReemplazo = () => {
    if (this.state.optionReemplazo === undefined) {
      return;
    }

    if (this.state.optionReemplazo === 2) {
      if (
        this.state.nuevaCantidad === undefined ||
        this.props.itemReemplazar === undefined ||
        this.props.itemReemplazar.cantidad === this.state.nuevaCantidad ||
        this.state.nuevaCantidad === 0
      ) {
        return;
      }

      let payload = {
        idPedido: this.props.id ? this.props.id : 0,
        idPedidoDetalle: this.props.itemReemplazar ? this.props.itemReemplazar.idDetallePedido : 0,
        nuevaCantidad: this.state.nuevaCantidad,
      };

      let callback = () => {
        this.setState({
          optionReemplazo: undefined,
          value: "",
          itemNuevo: undefined,
          cantidadOriginal: 0,
          cantidadNuevoArticulo: 0,
          nuevaCantidad: 0,
          itemAQuitar: undefined,
          isValidPassword: undefined,
          claveErrorMsg: undefined,
        });
      };

      this.props.handleOnClickGuardarReemplazo(payload, callback, false);
    } else {
      if (this.state.itemNuevo === undefined) {
        return;
      }

      if (
        this.props.itemReemplazar === undefined ||
        this.props.itemReemplazar.cantidad === this.state.cantidadNuevoArticulo ||
        this.state.cantidadNuevoArticulo === 0
      ) {
        return;
      }

      if (this.state.cantidadOriginal < 0 || this.state.cantidadNuevoArticulo < 0) {
        return;
      }

      let payload = {
        idPedido: this.props.id ? this.props.id : 0,
        idPedidoDetalle: this.props.itemReemplazar ? this.props.itemReemplazar.idDetallePedido : 0,
        cantidadPdOriginal: this.state.cantidadOriginal,
        idCatalogoEntrada: this.state.itemNuevo.idCatalogoEntrada
          ? this.state.itemNuevo.idCatalogoEntrada
          : 0,
        idArticulo: this.state.itemNuevo.idArticulo ? this.state.itemNuevo.idArticulo : 0,
        cantidadArticulo: this.state.cantidadNuevoArticulo,
      };

      let callback = () => {
        this.setState({
          optionReemplazo: undefined,
          value: "",
          itemNuevo: undefined,
          cantidadOriginal: 0,
          cantidadNuevoArticulo: 0,
          nuevaCantidad: 0,
          itemAQuitar: undefined,
          isValidPassword: undefined,
          claveErrorMsg: undefined,
        });
      };

      this.props.handleOnClickGuardarReemplazo(payload, callback, true);
    }
  };

  handleOnClickQuitar = (idPedido, idPedidoDetalle, nombre) => {
    let item = {
      idPedido: idPedido,
      idPedidoDetalle: idPedidoDetalle,
      nombre: nombre,
    };

    this.setState({ itemAQuitar: item });
  };

  handleOnClickBtnModalQuitar = (quitar) => {
    if (quitar === true) {
      let payload = {
        idPedido: this.state.itemAQuitar.idPedido,
        idPedidoDetalle: this.state.itemAQuitar.idPedidoDetalle,
      };

      payload.callback = () => {
        this.setState({ itemAQuitar: undefined });
      };

      this.props.handleOnQuitarPedidoDetalleReemplazo(payload);
    } else {
      this.setState({
        optionReemplazo: undefined,
        value: "",
        itemNuevo: undefined,
        cantidadOriginal: 0,
        cantidadNuevoArticulo: 0,
        nuevaCantidad: 0,
        itemAQuitar: undefined,
        isValidPassword: undefined,
        claveErrorMsg: undefined,
      });
    }
  };

  toFixedCustomize = (num) => {
    var resultado = num.toFixed(6).slice(0, -4);
    return resultado;
  };

  handleOnChangeInput = (event, name) => {
    let value = event.target.value;

    let splitValue = value.split(".");
    if (splitValue && splitValue.length > 1) {
      value = value.slice(0, splitValue[0].length + 3);
    }

    if (value === "") {
      this.setState({ [name]: 0 });
      return;
    }

    if (name === "cantidadNuevoArticulo") {
      if (!this.state.itemNuevo.esPesable && value.includes(".")) {
        return;
      }
    } else if (!this.props.itemReemplazar.productoPesable && value.includes(".")) {
      return;
    }

    if (isNaN(value)) {
      return;
    }

    if (value < 0) {
      return;
    }

    this.setState({ [name]: value });
  };

  handleOnClickDelete = () => {
    this.setState({
      value: "",
      itemNuevo: undefined,
      cantidadNuevoArticulo: 0,
    });
  };

  handleFocusTextfield = (event) => event.target.select();

  handleOnClickWhatsApp = () => {
    window.open(
      `http://wa.me/` +
        this.props.pedido.telefono.replace(/\s/g, "").replace("-", "").replace("+549", "54")
    );
  };

  renderImg = (value) => {
    return <img src={require(`../../images/${value}.png`)} alt="" />;
  };

  handleOnClickCambiarModalidad = () => {
    this.setState({ showBtnsModalidadTurnos: true }, () => {
      this.props.handleOnShowTurnero();
    });
  };

  handleOnClickTurno = (e, value) => {
    this.setState({ showBtnsModalidadTurnos: false });
    this.props.handleOnClickTurno(e, value);
  };

  handleOnKeyPressBusqueda = (event) => {
    if (event.key === "Enter") {
      this.props.handleOnClickBtnSearch();
    }
  };

  getTitleDatos = (pedido, descripcionMotivo, pickupText) => {
    const estadoDescripcion = pedido.estadoPedido?.descripcion || "";
    const motivoDescripcion =
      estadoDescripcion === "Eliminado" && descripcionMotivo ? `- ${descripcionMotivo}` : "";
    const origenPedido = `, Origen: ${getOrigenPedidoLabel(pedido)}`;
    const formaPago =
      pedido.idFormaPagoOnline === 5
        ? pedido.medioPagoOnline
          ? `, ${pedido.medioPagoOnline}`
          : ", Pago Online"
        : pedido.descripcionFormaPago
          ? `, ${pedido.descripcionFormaPago}`
          : "";
    const nroOperacion = pedido.idOperaciónMP ? `Nro.: ${pedido.idOperaciónMP}` : "";
    const turnoInfo = pedido.turno
      ? pedido.turno.idTipoCalendarioCodigoExterno === 1
        ? `, ${pickupText || "PICK-UP"} ${pedido.turno.fechaHora}`
        : `, DELIVERY ${pedido.turno.fechaHora}`
      : "";

    const isPickup = pedido.turno?.idTipoCalendarioCodigoExterno === 1;
    const localidadEntregaInfo =
      !isPickup && pedido.nombreLocalidadEntrega
        ? `, Localidad entrega: ${pedido.nombreLocalidadEntrega}`
        : "";

    return `(${estadoDescripcion}${motivoDescripcion}${origenPedido}${formaPago}${nroOperacion}${turnoInfo}${localidadEntregaInfo})`;
  };

  getImage = (pedido) => {
    if (!pedido || !pedido.turno) {
      return "pedidos";
    }

    return pedido.turno.idTipoCalendarioCodigoExterno === 1 ? "AvatarPickUp" : "AvatarDelivery";
  };

  render() {
    const { classes } = this.props;

    const { tipoFacturacion } = this.props.pedido;
    // console.log('this.props.pedido', this.props.pedido);
    const requireFacturacion = tipoFacturacion && tipoFacturacion.id === 2;

    return (
      <div>
        {!this.props.sucursal ? (
          <div></div>
        ) : !this.props.visualizacion ? (
          <div className="pedidosDetalle">
            <Dialog open={true} onClose={() => {}} fullWidth={true} className="pedidosDetalle">
              <DialogContentText>
                <div style={{ fontSize: "18px", textAlign: "center", marginBottom: "5px" }}>
                  No puedes trabajar con este pedido.
                </div>
                <div style={{ fontSize: "18px", textAlign: "center" }}>
                  Fue hecho en la sucursal <strong>{this.props.pedido.sucursalNombre}</strong>.
                </div>
              </DialogContentText>
              <DialogActions className="botones" style={{ textAlign: "center" }}>
                <Button
                  onClick={() => {
                    this.props.handleOnVolver();
                  }}
                  className="btnDragDropFlat"
                >
                  Volver
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        ) : (
          <div className="pedidoDetalle">
            {/* menú superior */}
            <TitleBar
              showImage={true}
              image={this.renderImg(this.getImage(this.props.pedido))}
              title={`Pedido  ${this.props.pedido.idPedido} - ${this.props.pedido.razonSocial}`}
              titleDatos={this.getTitleDatos(
                this.props.pedido,
                this.props.descripcionMotivo,
                this.props.pickupText,
                this.props.pedido.nombreLocalidadEntrega
              )}
              showSearch={false}
              showBtnInfo={true}
              handleOnClickBtnInfo={this.props.handleOnClickBtnInfo}
              handleOnClickBtnDetalleFraude={
                this.props.pedido.fraudePotencial
                  ? this.props.handleOnClickBtnDetalleFraude
                  : undefined
              }
              handleOnClickTurno={
                this.props.pedido.estadoPedido &&
                (this.props.pedido.estadoPedido.descripcion === "Confirmado" ||
                  this.props.pedido.estadoPedido.descripcion === "Preparado")
                  ? this.props.handleOnClickTurno
                  : undefined
              }
              handleOnClickGeorreferenciar={
                this.props.pedido.descripcionFormaEntrega === "DELIVERY" ||
                this.props.pedido.faltaGeoreferenciar
                  ? this.props.handleOnClickGeorreferenciar
                  : undefined
              }
              handleOnClickDatosFacturacion={
                requireFacturacion
                  ? () => this.props.handleShowDatosFacturacionModal(true)
                  : undefined
              }
              estadoPedido={this.props.pedido.estadoPedido.descripcion}
              colorIconLocation={this.props.pedido.faltaGeoreferenciar ? "red" : "#0C3653"}
              buttons={
                <div>
                  {this.props.pedido.estadoPedido.descripcion !== "Borrador" &&
                    this.props.pedido.estadoPedido.descripcion !== "Abandonado" &&
                    this.props.pedido.estadoPedido.descripcion !== "Eliminado" &&
                    /*this.props.pedido.estadoPedido.descripcion !== "Preparado") &&*/
                    (!this.props.expandirBotones ? (
                      <Button
                        className="btnContraerExpandir"
                        onClick={() => {
                          this.props.setExpandirBotones(true);
                        }}
                      >
                        <ChevronLeftIcon className="iconContraerExpandir" />
                      </Button>
                    ) : (
                      <Button
                        className="btnContraerExpandir"
                        onClick={() => {
                          this.props.setExpandirBotones(false);
                        }}
                      >
                        <ChevronRightIcon className="iconContraerExpandir" />
                      </Button>
                    ))}

                  {
                    <Button
                      variant="contained"
                      className="btnSecundario"
                      onClick={this.props.handleOnVolver}
                    >
                      Volver
                    </Button>
                  }

                  {/*{(this.props.pedido.estadoPedido.descripcion !== "Borrador" && this.props.pedido.estadoPedido.descripcion !== "Eliminado") && <Button variant="contained" className="btnSecundario" onClick={this.props.caratula}>
                Caratula</Button>}*/}

                  {(this.props.pedido.estadoPedido.descripcion === "Preparado" ||
                    this.props.pedido.estadoPedido.descripcion === "Entregado") && (
                    <Button
                      variant="contained"
                      className="btnSecundario"
                      onClick={this.props.remito}
                    >
                      Remito
                    </Button>
                  )}
                  {this.props.pedido.estadoPedido.descripcion === "Confirmado" && (
                    <Button
                      variant="contained"
                      className="btnSecundario"
                      onClick={this.props.remito}
                    >
                      Picking
                    </Button>
                  )}

                  {!(
                    (this.props.pedido.idFormaPagoOnline === 2 ||
                      this.props.pedido.idFormaPagoOnline === 3) &&
                    (this.props.pedido.estadoPedido.descripcion === "Entregado" ||
                      (this.props.pedido.estadoPedido.descripcion === "Preparado" &&
                        this.props.expandirBotones))
                  ) &&
                    (this.props.pedido.estadoPedido.descripcion === "Borrador" ||
                      (this.props.pedido.estadoPedido.descripcion === "Preparado" &&
                        this.props.expandirBotones) ||
                      (this.props.pedido.estadoPedido.descripcion === "Confirmado" &&
                        this.props.expandirBotones) ||
                      (this.props.pedido.estadoPedido.descripcion === "Pendiente" &&
                        this.props.expandirBotones)) && (
                      <Button
                        variant="contained"
                        className="btnSecundario"
                        onClick={this.props.handleOnEliminar}
                      >
                        Eliminar
                      </Button>
                    )}

                  {(((this.props.pedido.estadoPedido.descripcion === "Entregado" ||
                    this.props.pedido.estadoPedido.descripcion === "Preparado") &&
                    !(
                      this.props.pedido.idFormaPagoOnline === 2 ||
                      this.props.pedido.idFormaPagoOnline === 3
                    )) ||
                    this.props.pedido.estadoPedido.descripcion === "Confirmado" ||
                    this.props.pedido.estadoPedido.descripcion === "Abandonado") &&
                    (this.props.pedido.estadoPedido.descripcion === "Abandonado" ||
                      this.props.expandirBotones) && (
                      <Button
                        variant="contained"
                        className="btnSecundario"
                        onClick={this.props.handleOnRevertir}
                      >
                        Revertir
                      </Button>
                    )}

                  {this.props.pedido.estadoPedido.descripcion === "Confirmado" && (
                    <Button
                      variant="contained"
                      className="btnPrincipal"
                      onClick={this.props.handleOnPreparado}
                    >
                      Preparado
                    </Button>
                  )}

                  {this.props.pedido.estadoPedido.descripcion === "Preparado" && (
                    <Button
                      variant="contained"
                      className="btnPrincipal"
                      onClick={this.props.handleOnEntregado}
                    >
                      Entregado
                    </Button>
                  )}
                </div>
              }
            />

            {this.props.pedidoFiltrado !== undefined &&
              this.props.pedidoFiltrado.pedidoDetalles.length === 0 && (
                <div className="busquedaVacia">No se encontró ningun detalle de pedido</div>
              )}

            <div>
              {this.props.pedidoFiltrado !== undefined ? (
                <div>
                  <Row className="containerItemsPedidoDetalle">
                    {this.props.pedidoFiltrado.pedidoDetalles.map((pd, index) => (
                      <ItemDetallePedido
                        {...pd}
                        key={index}
                        estadoPedido={this.props.pedido.estadoPedido.descripcion}
                        idPedido={this.props.pedidoFiltrado.idPedido}
                        handleOnClickMarcarPedidoDetalleNoDisponible={
                          this.props.handleOnClickMarcarPedidoDetalleNoDisponible
                        }
                        marcarPedidoDetalleListo={this.props.marcarPedidoDetalleListo}
                        handleOnClickQuitar={this.handleOnClickQuitar}
                        instalacion={this.props.instalacion}
                      />
                    ))}
                  </Row>
                </div>
              ) : (
                <div>
                  <Row className="containerItemsPedidoDetalle">
                    {this.props.pedido &&
                      this.props.pedido.pedidoDetalles.map((pd, index) => (
                        <ItemDetallePedido
                          {...pd}
                          key={index}
                          estadoPedido={this.props.pedido.estadoPedido.descripcion}
                          idPedido={this.props.pedido.idPedido}
                          handleOnClickMarcarPedidoDetalleNoDisponible={
                            this.props.handleOnClickMarcarPedidoDetalleNoDisponible
                          }
                          marcarPedidoDetalleListo={this.props.marcarPedidoDetalleListo}
                          handleOnClickQuitar={this.handleOnClickQuitar}
                          instalacion={this.props.instalacion}
                        />
                      ))}
                  </Row>
                </div>
              )}
            </div>

            {/* BOTON WHATSAPP FLOTANTE */}
            {this.props.pedido && this.props.pedido.telefono && (
              <div className="buttonFlotanteContainer">
                <div className={`buscador ${this.props.openBuscador ? "buscadorActivo" : ""}`}>
                  {this.props.openBuscador === true && (
                    <InputBase
                      className="inputSearch"
                      placeholder="Buscar"
                      autocomplete="nope"
                      onChange={this.props.handleOnChangeFilter}
                      onKeyPress={this.handleOnKeyPressBusqueda}
                      value={this.props.valueBusqueda}
                      endAdornment={
                        <InputAdornment position="end">
                          {
                            <div className="iconClearBusqueda">
                              <ClearIcon onClick={this.props.handleOnClearBusqueda} />
                            </div>
                          }
                        </InputAdornment>
                      }
                    />
                  )}
                  <SearchIcon
                    fontSize="large"
                    style={{ color: "#FFFFFF", cursor: "pointer" }}
                    onClick={(e) => this.props.handleOnClickBtnSearch(e)}
                  />
                </div>
                <img
                  alt=""
                  src={require("../../images/whatsapp.png")}
                  onClick={this.handleOnClickWhatsApp}
                />
              </div>
            )}

            {/* QUITAR */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootQuitar }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.props.openModalTurno}
              fullWidth={true}
            >
              <DialogContent classes={{ root: classes.rootQuitar }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalQuitar">
                      <div className="labelDescripcionQuitar">Cambio de turno</div>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        {this.state.showBtnsModalidadTurnos === false && (
                          <div className="btnChange containerButtonsQuitar">
                            <Button
                              className="quitarBtn"
                              onClick={this.handleOnClickCambiarModalidad}
                            >
                              Cambiar modalidad
                            </Button>
                          </div>
                        )}

                        {((this.props.pedido?.turno?.idTipoCalendario === 2 &&
                          this.props.modalidadSelected !== 1) ||
                          this.props.modalidadSelected === 2) &&
                          !this.state.showBtnsModalidadTurnos && (
                            <Row>
                              <Col xs={12} style={{ padding: "0px 24px" }}>
                                <div className="inputContainer">
                                  <span className="label">Localidad</span>

                                  {this.props.localidadesEntregaActivas &&
                                    console.log(
                                      "📍 Coincide con alguna?",
                                      this.props.localidadesEntregaActivas.some((loc) => {
                                        const matches =
                                          loc.idLocalidadEntrega ==
                                          this.props.idLocalidadSeleccionada;
                                        return matches;
                                      })
                                    )}

                                  <Select
                                    classes={{
                                      icon: classes.icon,
                                      select: classes.select,
                                    }}
                                    style={{ width: "100%" }}
                                    IconComponent={ExpandMoreIcon}
                                    value={this.props.idLocalidadSeleccionada || ""}
                                    onChange={this.props.handleLocalidadChange}
                                    name="selectTurneroLocalidadDelivery"
                                  >
                                    {this.props.localidadesEntregaActivas &&
                                      this.props.localidadesEntregaActivas.map((localidad) => (
                                        <MenuItem
                                          key={localidad.idLocalidadEntrega}
                                          value={localidad.idLocalidadEntrega}
                                        >
                                          {localidad.descripcion}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </div>
                              </Col>
                            </Row>
                          )}

                        {this.state.showBtnsModalidadTurnos === true &&
                          this.props.showDireccion === false && (
                            <div className="btnChange containerButtonsQuitar">
                              <Button
                                className="quitarBtn"
                                onClick={(e) => this.handleOnClickTurno(e, modalidad.Pickup)}
                              >
                                Pickup
                              </Button>
                              <Button
                                className="quitarBtn"
                                onClick={(e) => this.handleOnClickTurno(e, modalidad.Delivery)}
                              >
                                Delivery
                              </Button>
                            </div>
                          )}

                        {this.state.showBtnsModalidadTurnos === false &&
                          this.props.showDireccion === false && (
                            <div>
                              <TurneroContainer
                                listaFechaHora={this.props.calendario}
                                diasAdelante={this.props.diasAdelante}
                                tipo={
                                  this.props.pedido &&
                                  this.props.pedido.turno &&
                                  this.props.pedido.turno.idTipoCalendarioCodigoExterno === 1
                                    ? "pickup"
                                    : "delivery"
                                }
                                handleOnClickDia={this.props.handleOnClickDia}
                                handleOnClickHorario={this.props.handleOnClickHorario}
                              />
                            </div>
                          )}

                        {this.state.showBtnsModalidadTurnos === false &&
                          this.props.showDireccion === true && (
                            <div>
                              <DomicilioEntregaContainer
                                domicilioSeleccionado={this.props.domicilioSeleccionado}
                                domicilios={this.props.pedido.listaDomicilios}
                                handleChangeRadioButtonDomicilio={
                                  this.props.handleChangeRadioButtonDomicilio
                                }
                                handleAfterSaveNuevoDomicilio={
                                  this.props.handleAfterSaveNuevoDomicilio
                                }
                                instalacion={this.props.instalacion}
                                usuario={{
                                  id: this.props.pedido
                                    ? this.props.pedido.usuarioRegistro
                                    : undefined,
                                }}
                              />
                            </div>
                          )}
                      </div>

                      <div className="containerButtonsQuitar">
                        <Button
                          className="cancelarBtn"
                          onClick={this.props.handleOnClickCerrarTurnos}
                        >
                          CERRAR
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/* QUITAR */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootQuitar }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.props.openModalGeorreferenciar}
              fullWidth={true}
            >
              <DialogContent classes={{ root: classes.rootQuitar }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalQuitar">
                      <div className="labelDescripcionQuitar" style={{ marginBottom: "20px" }}>
                        Georreferenciar domicilio del cliente
                      </div>

                      <DomicilioEntregaContainer
                        domicilioSeleccionado={this.props.domicilioSeleccionado}
                        domicilios={this.props.pedido.listaDomicilios}
                        handleChangeRadioButtonDomicilio={
                          this.props.handleChangeRadioButtonDomicilio
                        }
                        handleOnSaveGeorreferenciacion={this.props.handleOnSaveGeorreferenciacion}
                        instalacion={this.props.instalacion}
                        usuario={{
                          id: this.props.pedido ? this.props.pedido.usuarioRegistro : undefined,
                        }}
                        esGeorreferenciacion={true}
                        domicilioGeorreferenciacion={this.props.domicilioGeorreferenciacion}
                        handleOnClickGeorreferenciar={this.props.handleOnClickGeorreferenciar}
                      />
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/** confirmacion */}
            <Dialog
              id="ecommerce"
              disableBackdropClick={true}
              fullWidth={true}
              maxWidth={"sm"}
              open={this.props.openModalConfirm}
              onClose={this.props.handleOnCloseConfirmacion}
              classes={{ paperScrollPaper: classes.rootQuitar }}
            >
              <DialogContent classes={{ root: classes.rootContent }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalConfirmacion">
                      <div className="labelConfirmacion">{this.props.mensajeConfirmacion}</div>
                      <div className="containerBtnModalConfirmacion">
                        <Button
                          style={{ marginRight: "12px" }}
                          className="btnCancelar"
                          onClick={this.props.handleOnCloseConfirmacion}
                        >
                          Cancelar
                        </Button>
                        {this.props.botonOk.map ? (
                          this.props.botonOk.map((x, i) => (
                            <Button
                              key={x}
                              variant="contained"
                              className="borrarBtn"
                              onClick={() => {
                                this.props.handleOk[i]();
                                this.props.handleOnCloseConfirmacion();
                              }}
                            >
                              {x}
                            </Button>
                          ))
                        ) : (
                          <Button
                            variant="contained"
                            className="borrarBtn"
                            onClick={() => {
                              this.props.handleOk();
                              this.props.handleOnCloseConfirmacion();
                            }}
                          >
                            {this.props.botonOk}
                          </Button>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/* QUITAR */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootQuitar }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.state.itemAQuitar !== undefined}
              fullWidth={true}
            >
              <DialogContent classes={{ root: classes.rootQuitar }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalQuitar">
                      <div className="labelDescripcionQuitar">
                        Está por quitar el artículo{" "}
                        {this.state.itemAQuitar ? this.state.itemAQuitar.nombre : ""}
                      </div>

                      <div className="containerButtonsQuitar">
                        <Button
                          className="cancelarBtn"
                          onClick={() => this.handleOnClickBtnModalQuitar()}
                        >
                          Cancelar
                        </Button>
                        <Button
                          className="quitarBtn"
                          onClick={() => this.handleOnClickBtnModalQuitar(true)}
                        >
                          Quitar
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/* NO DISPONIBLE */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootQuitar }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.props.openModalNoDisponible}
              fullWidth={true}
            >
              <DialogContent classes={{ root: classes.rootQuitar }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalQuitar">
                      {!this.props.revertirNoDisponible ? (
                        <div
                          className="labelDescripcionQuitar"
                          style={{ font: "500 20px/24px Poppins" }}
                        >
                          {" "}
                          Al marcar como no disponible este artículo se dará de baja del catálogo de
                          productos
                        </div>
                      ) : (
                        <div
                          className="labelDescripcionQuitar"
                          style={{ font: "500 20px/24px Poppins" }}
                        >
                          Al marcar como disponible este artículo se dará de alta en el catálogo de
                          productos
                        </div>
                      )}

                      <div className="containerCheckbox">
                        <Checkbox
                          onChange={this.props.handleOnChangeCheckboxModal}
                          name="checkBoxNoMostrarModal"
                          checked={this.props.checkBoxNoMostrarModal}
                        />
                        <div className="textCheckbox">No me muestres más este mensaje</div>
                      </div>

                      <div className="containerButtonsQuitar">
                        <Button
                          className="cancelarBtn"
                          onClick={() =>
                            this.props.handleOnClickMarcarPedidoDetalleNoDisponible(false)
                          }
                        >
                          Cancelar
                        </Button>
                        <Button
                          className="guardarBtn"
                          onClick={() =>
                            this.props.handleOnClickMarcarPedidoDetalleNoDisponible(true)
                          }
                        >
                          Aceptar
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/* MOTIVO ELIMINACIÓN */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootQuitar }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.props.openModalMotivoEliminacion === true}
              fullWidth={true}
            >
              <DialogContent classes={{ root: classes.rootQuitar }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalQuitar">
                      <div className="labelDescripcionQuitar">
                        Indique el motivo de la eliminación
                      </div>

                      <div className="containerRadioBtn">
                        {this.props.motivosEliminacion &&
                          this.props.motivosEliminacion.length > 0 &&
                          this.props.motivosEliminacion.map((me) => {
                            return (
                              <div key={me.idMotivoEliminacion} className="itemMotivoEliminacion">
                                <FormControlLabel
                                  checked={
                                    this.props.motivoSeleccionado ===
                                    me.idMotivoEliminacion.toString()
                                  }
                                  onChange={(e) => this.props.handleChangeRadioButtonMotivo(e, me)}
                                  classes={{ label: classes.label }}
                                  value={me.idMotivoEliminacion.toString()}
                                  control={<RadioOrange />}
                                  label={me.descripcion}
                                />
                              </div>
                            );
                          })}
                      </div>

                      {this.props.habilitarInputOtro === true && (
                        <div className="containerOtroMotivo">
                          <span className="label">Ingrese el motivo</span>
                          <TextField
                            className="textareaMotivo"
                            name="motivoOtro"
                            type="text"
                            value={this.props.motivoOtro}
                            onChange={this.props.handleOnChangeInputMotivo}
                            multiline={true}
                          />
                        </div>
                      )}

                      {this.props.errorMotivo !== undefined && (
                        <FormHelperText error style={{ marginTop: "3px" }}>
                          {this.props.errorMotivo}
                        </FormHelperText>
                      )}

                      <div className="containerButtonsQuitar">
                        <Button
                          className="cancelarBtn"
                          onClick={() => this.props.handleOnClickMotivoEliminar(true)}
                        >
                          Cancelar
                        </Button>
                        <Button
                          className="eliminarBtn"
                          onClick={() => this.props.handleOnClickMotivoEliminar()}
                        >
                          Eliminar
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/* INFO USUARIO */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootQuitar }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.props.openModalInfoUsuario}
              fullWidth={true}
            >
              <DialogContent classes={{ root: classes.rootQuitar }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalQuitar">
                      <div className="labelTitleDatosUsuario">Datos de usuario</div>

                      <div className="campoInfo" style={{ marginTop: "22px" }}>
                        <div className="infoClave">Nombre y apellido</div>
                        <div className="infoValue">
                          {this.props.pedido.razonSocial
                            ? this.props.pedido.razonSocial
                            : "Sin Nombre y apellido"}
                        </div>
                      </div>

                      <div className="campoInfo" style={{ marginTop: "10px" }}>
                        <div className="infoClave">DNI</div>
                        {this.props.pedido && this.props.pedido.dni ? (
                          <NumberFormat
                            className="infoValueDni"
                            customInput={TextField}
                            inputProps={{
                              className: "infoValue",
                              style: { marginTop: "-5px", marginBlockEnd: "-5px" },
                            }}
                            background="white"
                            name="dni"
                            value={this.props.pedido.dni}
                            decimalScale={0}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            decimalSeparator={false}
                            thousandSeparator={"."}
                            isAllowed={({ value }) => value <= 99999999}
                          />
                        ) : (
                          <div className="infoValue">Sin DNI</div>
                        )}
                      </div>

                      <div className="campoInfo" style={{ marginTop: "8px" }}>
                        <div className="infoClave">Email</div>
                        <div className="infoValue">
                          {this.props.pedido.correo ? this.props.pedido.correo : "Sin Email"}
                        </div>
                      </div>

                      <div className="campoInfo" style={{ marginTop: "8px" }}>
                        <div className="infoClave">Teléfono:</div>
                        <div className="infoValue">{this.props.pedido.telefono}</div>
                      </div>

                      <div className="campoInfo" style={{ marginTop: "8px" }}>
                        <div className="infoClave">Direcciones</div>
                        {this.props.pedido.listaDomicilios ? (
                          this.props.pedido.listaDomicilios.map((domicilio) => (
                            <div
                              key={domicilio.idDomicilioEntrega}
                              className="infoValue"
                              style={{
                                paddingLeft:
                                  domicilio.idDomicilioEntrega ===
                                    this.props.pedido.idDomicilioEntrega &&
                                  this.props.pedido.descripcionFormaEntrega === "DELIVERY"
                                    ? "0px"
                                    : "30px",
                              }}
                            >
                              <div>
                                {" "}
                                {domicilio.idDomicilioEntrega ===
                                  this.props.pedido.idDomicilioEntrega &&
                                  this.props.pedido.descripcionFormaEntrega === "DELIVERY" && (
                                    <ShoppingCartOutlinedIcon className="shoppingCart" />
                                  )}{" "}
                                {domicilio.domicilio}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="infoValue2">Sin Direcciones</div>
                        )}
                      </div>

                      <div className="containerBtnCerrar">
                        <Button
                          className="btnCerrar"
                          onClick={() => this.props.handleOnClickBtnInfo()}
                          onFocus
                        >
                          CERRAR
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/* INFO FRAUDE */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootQuitar }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.props.openModalDetalleFraude}
              fullWidth={true}
            >
              <DialogContent classes={{ root: classes.rootQuitar }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalQuitar">
                      <div className="labelTitleDatosUsuario">Detalle Posible Fraude</div>

                      {this.props.pedido.fraudePotencialDetalle !== null &&
                        this.props.pedido.fraudePotencialDetalle.split("-").map((item, i) => (
                          <div key={`${item}-${i}`} className="campoInfo">
                            {item}
                          </div>
                        ))}

                      <div className="containerButtonsQuitar">
                        <Button
                          className="cancelarBtn"
                          onClick={() => this.props.handleOnClickBtnDetalleFraude()}
                        >
                          CERRAR
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/* TOTAL A PAGAR */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootQuitar }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.props.openModalTotalPagar}
              fullWidth={true}
            >
              <DialogContent classes={{ root: classes.rootQuitar }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalQuitar">
                      <div className="labelDescripcionQuitar">Finalizar picking de pedido</div>
                      <Row>
                        {/*<div class="col-xs-12">*/}
                        <div className="containerCantidad containerCantidadAux">
                          <CurrencyFormat
                            required
                            className="currencyInput"
                            customInput={TextField}
                            error={
                              this.props.errorTotalAPagar !== undefined ||
                              this.props.errorTotalAPagar === ""
                                ? true
                                : false
                            }
                            helperText={
                              this.props.errorTotalAPagar !== undefined ||
                              this.props.errorTotalAPagar === ""
                                ? this.props.errorTotalAPagar
                                : ""
                            }
                            label="Monto total a pagar"
                            style={{
                              width: "100%",
                              marginTop: "20px",
                              textAlign: "right",
                              marginLeft: "36px",
                            }}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            decimalSeparator="."
                            thousandSeparator=","
                            prefix={"$"}
                            value={this.props.totalAPagar}
                            onValueChange={this.props.handleOnChangeTotalAPagar}
                          />

                          {this.props.pedido.envioBonificado ? (
                            <div className="labelInfoTotal" style={{ paddingRight: "20%" }}>
                              *Envío bonificado por compra superior a{" "}
                              {formatMoney(this.props.pedido.montoEnvioBonificado)}.
                            </div>
                          ) : (
                            this.props.pedido.envioDomicilio !== undefined &&
                            this.props.pedido.envioDomicilio !== null && (
                              <div className="labelInfoTotal" style={{ paddingRight: "2%" }}>
                                *El monto total a pagar debe incluir el monto de{" "}
                                {formatMoney(this.props.pedido.envioDomicilio)} de costo de envio.
                              </div>
                            )
                          )}
                        </div>
                      </Row>

                      {/*</div>*/}

                      <Row style={{ flexWrap: "nowrap" }}>
                        {/*<div class="col-xs-12 col-sm-4">*/}
                        <div className="containerCantidad">
                          <NumberFormat
                            className="currencyInput"
                            customInput={TextField}
                            label="Bolsas fríos"
                            style={{ width: "100%", textAlign: "right", marginLeft: "36px" }}
                            decimalScale={0}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            decimalSeparator={false}
                            thousandSeparator={"."}
                            onValueChange={this.props.handleOnChangeBolsasFrios}
                          />
                        </div>
                        {/*</div>*/}

                        {/*<div class="col-xs-12 col-sm-4">*/}
                        <div className="containerCantidad">
                          <NumberFormat
                            className="currencyInput"
                            customInput={TextField}
                            label="Bolsas congelados"
                            style={{ width: "100%", textAlign: "right", marginLeft: "10px" }}
                            decimalScale={0}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            decimalSeparator={false}
                            thousandSeparator={"."}
                            onValueChange={this.props.handleOnChangeBolsasCongelados}
                          />
                        </div>
                        {/*</div>*/}

                        {/*<div class="col-xs-12 col-sm-4">*/}
                        <div className="containerCantidad">
                          <NumberFormat
                            className="currencyInput"
                            customInput={TextField}
                            label="Canastos"
                            style={{ width: "100%", textAlign: "right", marginLeft: "10px" }}
                            decimalScale={0}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            decimalSeparator={false}
                            thousandSeparator={"."}
                            onValueChange={this.props.handleOnChangeCanastos}
                          />
                        </div>
                        {/*</div>*/}
                      </Row>
                      <Row style={{ flexWrap: "nowrap" }}>
                        <div className="containerObservaciones contObs">
                          <TextField
                            className="labelObservaciones"
                            label="Observaciones"
                            name="observacionPicking"
                            style={{ width: "100%" }}
                            onChange={this.props.handleOnChangeObservacionPicking}
                            multiline
                            rows={4}
                          />
                        </div>
                      </Row>

                      <Row>
                        <div className="containerButtonsQuitarFinalizarPicking">
                          <Button
                            className="cancelarBtn"
                            onClick={() => this.props.handleOnClickTotalAPagar(false)}
                          >
                            Cancelar
                          </Button>
                          <Button
                            className="guardarBtn"
                            onClick={() => this.props.handleOnClickTotalAPagar(true)}
                          >
                            Guardar
                          </Button>
                        </div>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/* Reemplazar */}
            <Dialog
              classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootContent }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              open={this.props.modalReemplazar}
              fullWidth={true}
              onClose={this.modalReemplazarClose}
            >
              <DialogContent classes={{ root: classes.rootContent }}>
                <Row style={{ margin: "0px" }}>
                  <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                    <div className="containerModalReemplazo">
                      <div className="labelTitle">REEMPLAZAR PRODUCTO</div>

                      <div className="descripcion">
                        {this.props.itemReemplazar.descripcion} X
                        {this.props.itemReemplazar.cantidad} u $
                        {this.props.itemReemplazar.precioFinal}
                      </div>

                      <div className="labelReemplazarPor">Reemplazar por:</div>

                      <div className="containerOptions">
                        {/* {this.props.itemReemplazar.permisoReemplazo === true &&  */}
                        <div
                          className="labelBtn"
                          onClick={() => this.handleOnClickOptionReemplazoSelected(1)}
                        >
                          Otro Articulo
                        </div>

                        <div
                          className={`labelBtn ${this.props.itemReemplazar.permisoReemplazo === false ? "labelBtnAux" : ""}`}
                          onClick={() => this.handleOnClickOptionReemplazoSelected(2)}
                        >
                          Distinta cantidad del mismo articulo
                        </div>
                      </div>
                      {this.state.optionReemplazo === 1 &&
                        (this.props.itemReemplazar.permisoReemplazo === true ||
                          this.state.isValidPassword) && (
                          <div className="containerNewPedidoDetalle">
                            <div className="labelNuevoProducto" style={{ marginRight: "20px" }}>
                              Nuevo producto
                            </div>

                            <div className="containerInputsProductos">
                              <div className="containerAutocompletado">
                                <Autocomplete
                                  getItemValue={this.getItemValue}
                                  items={this.props.sugerenciasReemplazo}
                                  renderItem={this.renderItem}
                                  value={this.state.value}
                                  onChange={this.onChange}
                                  onSelect={this.onSelect}
                                />
                              </div>

                              <div className="containerCantidad">
                                <input
                                  type="text"
                                  className="cantidad cantidadInput"
                                  value={this.state.cantidadNuevoArticulo}
                                  onInput={(event) =>
                                    this.handleOnChangeInput(event, "cantidadNuevoArticulo")
                                  }
                                  onFocus={this.handleFocusTextfield}
                                />
                              </div>

                              <div className="inputPrecio">
                                <input
                                  disabled={true}
                                  style={{ width: "100px" }}
                                  value={`$ ${this.state.itemNuevo ? this.toFixedCustomize(this.state.cantidadNuevoArticulo * (this.state.itemNuevo.precioPromocional ? this.state.itemNuevo.precioPromocional : this.state.itemNuevo.precioLista)) : "0.00"}`}
                                />
                              </div>

                              <div className="iconDelete" onClick={this.handleOnClickDelete}>
                                <DeleteIcon />
                              </div>
                            </div>

                            <div className="containerCantidadOriginal">
                              <div className="nuevaCantidad" style={{ marginRight: "20px" }}>
                                Producto original
                              </div>
                              <div className="containerInputsProductos">
                                <input
                                  type="text"
                                  style={{ textAlign: "left" }}
                                  className="input"
                                  value={this.props.itemReemplazar.descripcion}
                                  disabled={true}
                                />
                                <input
                                  type="text"
                                  className="input inputWidth"
                                  value={this.state.cantidadOriginal}
                                  onInput={(event) =>
                                    this.handleOnChangeInput(event, "cantidadOriginal")
                                  }
                                  onFocus={this.handleFocusTextfield}
                                />
                                <input
                                  type="text"
                                  className="input inputPrecioOriginal"
                                  value={`$ ${this.toFixedCustomize(this.state.cantidadOriginal * (this.props.itemReemplazar.precioUnitarioPromocional ? this.props.itemReemplazar.precioUnitarioPromocional : this.props.itemReemplazar.precioUnitario))}`}
                                  disabled={true}
                                />
                                <div style={{ minWidth: "30px", maxWidth: "30px" }}></div>
                              </div>
                            </div>
                          </div>
                        )}

                      {this.state.optionReemplazo === 2 && (
                        <div className="containerCantidad">
                          <div className="nuevaCantidad">Nueva cantidad</div>
                          <input
                            type="text"
                            className="cantidad cantidadInput"
                            value={this.state.nuevaCantidad}
                            onInput={(event) => this.handleOnChangeInput(event, "nuevaCantidad")}
                            onFocus={this.handleFocusTextfield}
                          />
                        </div>
                      )}

                      {this.state.optionReemplazo === 1 &&
                        this.props.itemReemplazar.permisoReemplazo === false &&
                        !this.state.isValidPassword && (
                          <>
                            <div className="containerCantidad">
                              <div className="nuevaCantidad">Ingrese la clave del supervisor</div>
                              <div
                                className="containerCantidad"
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                <input
                                  type="password"
                                  autoComplete="nope"
                                  name="oldPassword"
                                  className="removeEye"
                                  value={this.state.oldPassword}
                                  onChange={this.handleOnChangeInputClave}
                                  style={{ marginTop: "15px", textAlign: "center" }}
                                />
                                <Button
                                  className="chequear"
                                  onClick={() =>
                                    this.handleOnClickCheckPassword(this.state.oldPassword)
                                  }
                                >
                                  ✔
                                </Button>
                              </div>
                            </div>
                            <p style={{ color: "red", marginTop: 4 }}>
                              {this.state.claveErrorMsg || ""}
                            </p>
                          </>
                        )}

                      <div className="containerButtonsReemplazo">
                        <Button className="cancelarReemplazo" onClick={this.modalReemplazarClose}>
                          Cancelar
                        </Button>
                        <Button
                          className="guardarReemplazo"
                          onClick={this.handleOnClickGuardarReemplazo}
                        >
                          Guardar
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>

            {/** ver Pedido */}
            <Dialog
              id="ecommerce"
              disableBackdropClick={false}
              fullWidth={false}
              maxWidth={"sm"}
              open={this.props.modalVerPedido}
              onClose={this.props.modalVerPedidoClose}
            >
              <div style={{ width: "525px", paddingBottom: "12px" }}>
                <div
                  style={{
                    padding: "5px",
                    textAlign: "left",
                    borderBottom: "solid 1px black",
                    fontSize: "32px",
                  }}
                >
                  {this.props.itemVisto.descripcion}
                </div>
                <div
                  style={{
                    width: "50%",
                    display: "inline-block",
                    padding: "5px",
                    textAlign: "center",
                  }}
                >
                  <img
                    src={this.props.itemVisto.imagen}
                    style={{ width: "250px", height: "435px", objectFit: "cover" }}
                    alt=""
                  ></img>
                </div>
                <div
                  style={{ width: "50%", float: "right", display: "inline-block", padding: "5px" }}
                >
                  <div style={{ height: "260px" }}>
                    <img
                      src={this.props.itemVisto.imagenColor}
                      style={{
                        backgroundColor: this.props.itemVisto.color,
                        width: "250px",
                        height: "250px",
                        objectFit: "cover",
                        float: "left",
                      }}
                      alt=""
                    ></img>
                  </div>
                  <div style={{ fontSize: "14px" }}>{"Talle: " + this.props.itemVisto.talle}</div>
                  <div style={{ fontSize: "14px" }}>
                    {"$" + Money(this.props.itemVisto.precioFinal)}
                  </div>
                  <div style={{ marginTop: "10px", fontSize: "34px" }}>
                    {this.props.itemVisto.cantidad}
                  </div>
                  <div style={{ marginTop: "10px", fontSize: "16px" }}>
                    {this.props.itemVisto.codigoArticulo}
                  </div>
                </div>
                {/* botonera */}
                <div style={{ textAlign: "left", marginTop: "6px", paddingLeft: "55%" }}>
                  <Button
                    style={{ marginRight: "12px" }}
                    className="btnSecundario"
                    onClick={this.props.modalVerPedidoClose}
                  >
                    Volver
                  </Button>
                  {this.props.pedido.estadoPedido.descripcion === "Confirmado" && (
                    <Button
                      variant="contained"
                      className="btnPrincipal"
                      onClick={() => {
                        this.props.modalVerPedidoOk();
                        this.props.modalVerPedidoClose();
                      }}
                    >
                      {this.props.itemVisto.listo ? "Revertir" : "Listo"}
                    </Button>
                  )}
                </div>
              </div>
            </Dialog>

            {/* MODAL DATOS DE FACTURACION */}
            {this.props.showDatosFacturacionModal && (
              <DatosFacturacionModal
                clienteDatosFacturacion={this.props.pedido.clienteDatosFacturacion}
                handleOnCerrar={() => this.props.handleShowDatosFacturacionModal(false)}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

PedidoDetalle.propTypes = {
  pedido: PropTypes.object.isRequired,
  visualizacion: PropTypes.bool,
  sucursal: PropTypes.object,
  calendario: PropTypes.object,
  openModalMotivoEliminacion: PropTypes.bool,
  motivosEliminacion: PropTypes.array,
  showDatosFacturacionModal: PropTypes.bool,
  marcarPedidoDetalleListo: PropTypes.func,
  obtenerSugerencias: PropTypes.func,
  marcarPedidoDetalleNoDisponible: PropTypes.func,
  handleOnClickMarcarPedidoDetalleNoDisponible: PropTypes.func,
  handleOnChangeCheckboxModal: PropTypes.func,
  handleOnQuitarPedidoDetalleReemplazo: PropTypes.object.isRequired,
  handleOnClickTotalAPagar: PropTypes.func,
  handleOnClickBtnInfo: PropTypes.func,
  handleOnClickTurno: PropTypes.func,
  handleOnClickDia: PropTypes.func,
  handleOnClickHorario: PropTypes.func,
  handleOnClickCerrarTurnos: PropTypes.func,
  handleOnShowTurnero: PropTypes.func,
  handleChangeRadioButtonDomicilio: PropTypes.func,
  handleAfterSaveNuevoDomicilio: PropTypes.func,
  handleOnClickGeorreferenciar: PropTypes.func,
  handleOnSaveGeorreferenciacion: PropTypes.func,
  handleChangeRadioButtonMotivo: PropTypes.func,
  handleOnChangeInputMotivo: PropTypes.func,
  handleOnClickMotivoEliminar: PropTypes.func,
  handleOnChangeCanastos: PropTypes.func,
  handleOnChangeObservacionPicking: PropTypes.func,
  handleOnClickBtnSearch: PropTypes.func,
  handleOnChangeFilter: PropTypes.func,
  handleOnClearBusqueda: PropTypes.func,
  handleShowDatosFacturacionModal: PropTypes.func,
  handleOnClickBtnDetalleFraude: PropTypes.func,
  pickupText: PropTypes.string,
  handleLocalidadChange: PropTypes.func,
  localidadesEntregaActivas: PropTypes.array,
  idLocalidadSeleccionada: PropTypes.number,
  handleOnClickTurnosDeliveryPorLocalidadEspecifica: PropTypes.func,
};

PedidoDetalle.defaultProps = {
  calendario: [],
  showDatosFacturacionModal: false,
  handleOnClickDia: (f) => f,
  handleOnClickHorario: (f) => f,
  handleOnClickCerrarTurnos: (f) => f,
  handleOnShowTurnero: (f) => f,
  handleChangeRadioButtonDomicilio: (f) => f,
  handleAfterSaveNuevoDomicilio: (f) => f,
  handleOnClickGeorreferenciar: (f) => f,
  handleOnSaveGeorreferenciacion: (f) => f,
  handleChangeRadioButtonMotivo: (f) => f,
  handleOnChangeInputMotivo: (f) => f,
  handleOnClickMotivoEliminar: (f) => f,
  handleOnChangeCanastos: (f) => f,
  handleOnChangeObservacionPicking: (f) => f,
  handleOnClickBtnSearch: (f) => f,
  handleOnChangeFilter: (f) => f,
  handleOnClearBusqueda: (f) => f,
  handleShowDatosFacturacionModal: (f) => f,
  handleOnClickBtnDetalleFraude: (f) => f,
  handleLocalidadChange: (f) => f,
  localidadesEntregaActivas: [],
  idLocalidadSeleccionada: null,
  handleOnClickTurnosDeliveryPorLocalidadEspecifica: (f) => f,
  pickupText: "PICK-UP",
};

export default withStyles(styles)(PedidoDetalle);
